export { default } from "./QuizWarningMessage";
